import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type UpdateUserProfileMutationVariables = Types.Exact<{
    input: Types.UserProfileInput;
}>;

export type UpdateUserProfileMutation = { __typename?: 'Mutation' } & {
    updateUserProfile?: Types.Maybe<
        { __typename?: 'UserProfile' } & Pick<
            Types.UserProfile,
            | 'situationWhatIsYourCurrentPropertyGoal'
            | 'situationAreYouAFirstTimeBuyer'
            | 'situationAreYouSellingAProperty'
            | 'situationIsItAlreadyOnTheMarket'
            | 'situationAreYouAPropertyInvestor'
            | 'situationAreYouLookingToBuy'
            | 'situationAreYouAHomeowner'
        >
    >;
};

export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($input: UserProfileInput!) {
        updateUserProfile(input: $input) {
            situationWhatIsYourCurrentPropertyGoal
            situationAreYouAFirstTimeBuyer
            situationAreYouSellingAProperty
            situationIsItAlreadyOnTheMarket
            situationAreYouAPropertyInvestor
            situationAreYouLookingToBuy
            situationAreYouAHomeowner
        }
    }
`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateUserProfileMutation,
        UpdateUserProfileMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateUserProfileMutation,
        UpdateUserProfileMutationVariables
    >(UpdateUserProfileDocument, options);
}
export type UpdateUserProfileMutationHookResult = ReturnType<
    typeof useUpdateUserProfileMutation
>;
export type UpdateUserProfileMutationResult =
    Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
>;
